import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {StaticPagesPage} from './static-pages.page';

const routes: Routes = [
    {
        path: '', redirectTo: '/home', pathMatch: 'full'
    },
    {
        path: ':alias',
        component: StaticPagesPage
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LoginPageRoutingModule {
}
